import { Injectable } from "@angular/core";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class WavetrendService extends BaseService {

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }
  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastWavePerformance").subscribe(
      (data: any) => {
        console.log("broadcastWavePerformance", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          let lineData = [];
          let category = [];
          let hasData: boolean = false;

          for (let i = 0; i < result.length; i++) {
            if (!widget.IfNoDataFound) {
              hasData = true;
              category.push(result[i].WaveNumber);
              lineData.push([result[i].WaveNumber, result[i].TotalWaveTime, result[i].WaveDescription]);
            }
          }

          if (!hasData) {
            widget.errorMessage = errorMessages.noWidgetData;
          }
          else {
            widget.errorMessage = null;
          }
          this.addDataSeries(widget.chartOptions, lineData, 'Wave Process Time', 'line')
          widget.chartOptions.xAxis.data = category;
          widget.chartOptions.grid.left = '6%';
          widget.chartOptions.grid.bottom = '6%';
          widget.chartOptions.xAxis.axisLabel.rotate = 45;
          this.addZoomBar(widget.chartOptions);
          this._commonService.lastUpdatedTime = lastUpdatedTime;

        }

        if (widget.IfNoDataFound) {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        widget.dataLoaded = true;
      },
      err => {
        console.log("listenFor broadcastWavePerformance error", err);
      }
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/wavetrend.service.ts